import { Component, OnInit } from '@angular/core';
import { E5coreUiGenerateDocumentBaseComponent } from './e5core-ui-generate-document-base';

@Component({
  selector: 'e5core-ui-generate-document-box',
  templateUrl: './e5core-ui-generate-document-box.component.html',
  styleUrls: ['./e5core-ui-generate-document-box.component.css']
})
export class E5coreUiGenerateDocumentBoxComponent extends E5coreUiGenerateDocumentBaseComponent implements OnInit{
}